//user types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED'
export const SET_USER = 'SET_USER'
export const LOADING_USER = 'LOADING_USER'
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ'

//UI types
export const SET_ERRORS = 'SET_ERRORS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const LOADING_UI = 'LOADING_UI'
export const STOP_LOADING = 'STOP_LOADING'
export const TOGGLE_THEME = "TOGGLE_THEME"

//data types
export const LOADING_POSTS = 'LOADING_POSTS'
export const SET_POSTS = 'SET_POSTS'
export const LIKE_POST = 'LIKE_POST'
export const UNLIKE_POST = 'UNLIKE_POST'
export const DELETE_POST = 'DELETE_POST'
export const ADD_POST = 'ADD_POST'
export const SET_POST = ' SET_POST'
export const ADD_COMMENT = 'ADD_COMMENT'

